/** Returns whether a field-level error belongs to a step field or one of its children. */
export function fieldMatchesStep(errorField = '', stepField = '') {
  return errorField === stepField || errorField.startsWith(`${stepField}.`);
}

/** Finds the first form step containing a server or client validation error. */
export function firstStepWithErrors(fieldErrors = {}, stepFields = {}, fallbackStep = '') {
  const errorFields = Object.entries(fieldErrors)
    .filter(([, message]) => Boolean(message))
    .map(([field]) => field);

  if (!errorFields.length) return '';

  const match = Object.entries(stepFields).find(([, fields]) => (
    fields.some((field) => errorFields.some((errorField) => fieldMatchesStep(errorField, field)))
  ));

  return match?.[0] || fallbackStep;
}

/** Navigates to and reveals the first invalid step; returns whether a step was selected. */
export function showFirstStepWithErrors(fieldErrors, stepFields, fallbackStep, goToSection) {
  const step = firstStepWithErrors(fieldErrors, stepFields, fallbackStep);
  if (!step) return false;
  goToSection(step);
  requestAnimationFrame(() => {
    document.querySelector('.hobby-flow-stepper')?.scrollIntoView({ block: 'start', behavior: 'smooth' });
  });
  return true;
}
